import { useState, useRef, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import posService from "../../services/pos/pos.service";
import RawMaterialService from "../../services/RawMaterials/RawMaterialService";

interface OutwardRawMaterialsProps {
  visible: boolean;
  onHide: () => void;
  rawmaterial: any;
  onSuccess: (posId: number) => void; 
  setLoading: (loading: boolean) => void;
}

interface SourceType {
  id: number;
  name: string;
}

const OutwardRawMaterials: React.FC<OutwardRawMaterialsProps> = ({ visible, onHide, rawmaterial, onSuccess, setLoading }) => {
  const toast = useRef<Toast>(null);
  const [quantity, setQuantity] = useState<number>(0);
  const [sourceTypes, setSourceTypes] = useState<SourceType[]>([]);
  const [selectedSourceType, setSelectedSourceType] = useState<SourceType | null>(null);
  const [posOptions, setposOptions] = useState<any[]>([]);
  const [selectedPOS, setselectedPOS] = useState<string | null>(null);
  const [batchCode, setBatchCode] = useState<string>("");
  const [note, setNote] = useState<string>("");

  const [vendorOptions, setVendorOptions] = useState<any[]>([]);
  const [selectedVendor, setSelectedVendor] = useState<any | null>(null);
  debugger
  const [invoiceOptions, setInvoiceOptions] = useState<any[]>([]);
  debugger
  const [selectedInvoice, setSelectedInvoice] = useState<any | null>(null);
  
  const loadSourceTypeDropdown = async () => {
  try {
    const response = await posService.GetOutwardSourceType(); // adjust to your service method
    debugger
    if (Array.isArray(response)) {
        debugger
      setSourceTypes(response);
    }
  } catch (error) {
    console.error("Failed to load source types", error);
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "Could not load source type data",
    });
  }
};


const loadPOSOptions = async () => {
  try {
    const posData = await RawMaterialService.GetRemainingMFPOS(rawmaterial.posId);
    if (Array.isArray(posData)) {
        debugger
      setposOptions(posData);
    } else {
      setposOptions([]);
    }
  } catch (error) {
    console.error("Error loading POS options", error);
    toast.current?.show({
      severity: "error",
      summary: "Error",
      detail: "Could not load POS options",
    });
  }
};

   const loadVendors = async () => {
    try {
      const data = {
        rawMaterialId: rawmaterial.rawMaterialId,
        posId: rawmaterial.posId,
      };
      const vendors = await RawMaterialService.GetVendorandInvoiceWiseQty(data);
      debugger
      setVendorOptions(Array.isArray(vendors) ? vendors : []);
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Could not load vendors",
      });
    }
  };


  useEffect(() => {
        if (visible) {
          loadSourceTypeDropdown();
          loadVendors();
        }
        if (!visible) {
        setQuantity(0);
        setSelectedSourceType(null);
        setselectedPOS(null);
        setBatchCode("");
        setNote("");
        setSelectedVendor(null);
        setSelectedInvoice(null);
        setVendorOptions([]);
        setInvoiceOptions([]);
      }
      }, [visible]);

  useEffect(() => {
  if (selectedSourceType?.name === "POS") {
    loadPOSOptions();
  }
}, [selectedSourceType]);

useEffect(() => {
    if (selectedVendor) {
      const vendor = vendorOptions.find(v => v.vendorId === selectedVendor);
      setInvoiceOptions(vendor?.invoices || []);
    } else {
      setInvoiceOptions([]);
    }
  }, [selectedVendor]);

  const handleSubmit = async () => {
 if (!quantity || quantity <= 0) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please enter a valid quantity.",
    });
    return;
  }

  if (!selectedSourceType) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please select a source type.",
    });
    return;
  }

  if (selectedSourceType.name === "POS" && !selectedPOS) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please select a POS.",
    });
    return;
  }

 if (!selectedVendor) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "Please select a vendor.",
      });
      return;
    }
  

  if (selectedSourceType.name === "Others" && !note.trim()) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please enter a note for 'Others' source type.",
    });
    return;
  }

  if (!batchCode.trim()) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please enter a document Details.",
    });
    return;
  }

  if (quantity > rawmaterial.currentStock) {
  toast.current?.show({
    severity: "warn",
    summary: "Validation Error",
    detail: `Entered quantity exceeds available stock (${rawmaterial.currentStock}).`,
  });
  return;
}

if (rawmaterial.measurementTypeId === 4 && !Number.isInteger(quantity)) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Decimal quantities are not allowed for this product.",
    });
    return;
  }



  if (selectedVendor && !selectedInvoice) {
    toast.current?.show({
      severity: "warn",
      summary: "Validation Error",
      detail: "Please select an invoice for the selected vendor.",
    });
    return;
  }

  if (selectedInvoice?.quantity && quantity > selectedInvoice.quantity) {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: `Quantity exceeds available for selected invoice (${selectedInvoice.quantity}).`,
      });
      return;
    }

    const payload = {
    rawMaterialId: rawmaterial.rawMaterialId,  
    Posid: rawmaterial.posId,           
    Quantity: quantity,
    SourceTypeId: selectedSourceType?.id,
    toPosid: selectedPOS ? selectedPOS : 0,             
    DocumentDetails: batchCode,
    Note: note ,
    VendorId: selectedVendor,
    InvoiceNumber: selectedInvoice?.invoiceNumber,
    RawMaterialPurchaseId: selectedInvoice?.rawMaterialPurchaseId 
  };
debugger
    try {
    setLoading(true);
    const response = await RawMaterialService.AddRawMaterialOutward(payload);
      if (response && response.isSuccess) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message || "Outward data submitted successfully",
        });
        onHide(); // Close modal on success
        onSuccess(rawmaterial.posId); 
      } else {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: response?.message || "Failed to submit Outward data",
        });
      }
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "An error occurred during submission",
      });
    }finally {
    setLoading(false); // Always stop loading
  }
  };

  return (
    <>
      <Toast ref={toast} />
      <Dialog header="Outward Raw Material" visible={visible} onHide={onHide} breakpoints={{ '960px': '90vw' }} style={{ width: '30vw' }} modal>
        <div className="p-inputtext p-component bg-gray-100 py-2 px-3 rounded">
          {rawmaterial?.rawMaterialName || '-'}
        </div>
        <div className="p-fluid">
        <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Quantity <span className="text-danger">*</span></label>
          <InputText type="number" min="0" keyfilter="pnum" onChange={(e) => setQuantity(+e.target.value)} 
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
        </div>

         <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Source Type</label>
          <div className="flex gap-3 mb-3">
            {sourceTypes.map((type) => (
              <div key={type.id}>
                <RadioButton
                  inputId={`sourceType-${type.id}`}
                  name="sourceType"
                  value={type}
                  onChange={(e) => setSelectedSourceType(e.value)}
                  checked={selectedSourceType?.id === type.id}
                />
                <label htmlFor={`sourceType-${type.id}`} className="ml-2">
                  {type.name}
                </label>
              </div>
            ))}
          </div>
          </div>

          {selectedSourceType?.name === "POS" && (
          <div className="mb-3">
            <label className="font-semibold text-sm block mb-1">Select POS</label>
            <Dropdown
              value={selectedPOS}
              options={posOptions}
              optionLabel="posCode" // adjust based on your API's response
              optionValue="posID"   // adjust based on your API's response
              onChange={(e) => setselectedPOS(e.value)}
              placeholder="Select POS"
              style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
            />
          </div>
          )}

            {/* Vendor Dropdown */}
          <div className="mb-3">
            <label className="font-semibold text-sm block mb-1">Vendor</label>
              <Dropdown
                  value={selectedVendor}
                  options={vendorOptions}
                  optionLabel="vendorName"
                  optionValue="vendorId"
                  style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
                  onChange={(e) => setSelectedVendor(e.value)}
                  placeholder="Select Vendor"
                  itemTemplate={(option) => (
                    <div>
                      {option.vendorName} - {option.totalQuantity}
                    </div>
                  )}
                  valueTemplate={(option) =>
                    option ? `${option.vendorName} - ${option.totalQuantity}` : "Select Vendor"
                  }
            />
          </div>

          {/* Invoice Dropdown */}
          {selectedVendor && (
            <div className="mb-3">
              <label className="font-semibold text-sm block mb-1">Invoice Number</label>
            <Dropdown
                  value={selectedInvoice?.invoiceNumber || null}
                  options={invoiceOptions}
                  style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
                  optionLabel="invoiceNumber"
                  optionValue="invoiceNumber"
                  onChange={(e) => {
                    const selected = invoiceOptions.find((inv) => inv.invoiceNumber === e.value);
                    setSelectedInvoice(selected);
                  }}
                  placeholder="Select Invoice"
                  itemTemplate={(option) => (
                    <div>
                      {option.invoiceNumber} - {option.quantity}
                    </div>
                  )}
                  valueTemplate={(option) =>
                    option ? `${option.invoiceNumber} - ${option.quantity}` : "Select Invoice"
                  }
            />
            </div>
          )}

        <div className="mb-3">
          <label className="font-semibold text-sm block mb-1">Document Details</label>
          <InputText value={batchCode} onChange={(e) => setBatchCode(e.target.value)} 
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
        </div>

          <label className="font-semibold text-sm block mb-1">
            Note {selectedSourceType?.name === "Others" && <span className="text-red-500">*</span>}
          </label>
          <InputText value={note} onChange={(e) => setNote(e.target.value)} 
           maxLength={255}
          style={{ border: '1px solid #ced4da', borderRadius: '4px' }}
          />
           <small style={{ display: 'block', marginTop: '5px', color: '#6c757d' }}>
            {note.length} / 255
          </small>

          <Button label="Submit" className="mt-4" onClick={handleSubmit} />
        </div>
      </Dialog>
    </>
  );
};

export default OutwardRawMaterials;
